import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Queue from "nq";
import AppProvider from "./AppProvider";
import SignInPage from "./pages/signin/SignInPage";
import MainPage from "./pages/main/MainPage";
import SignUpPage from "./pages/signup/SignUpPage";
import TenantPage from "./pages/AppTenantPage";
import AboutUsPage from "./AboutUs/AboutUsPage";
import HomePage from "./pages/Homepage/HomePage";
import NotFoundPage from "./pages/notfound";
import SolutionsPage from "./Solutions/SolutionsPage";
import ContactPage from "./Contact/ContactPage";
import HRISPage from "./HRIS/HRISPage"
import DMSPage from "./DMS/DMSPage"
import BISPage from "./BIS/BISPage";



Queue.setUrl("https://api.innque.com/v1");
Queue.setApplicationId("tenth-corp"); // Replace with your actual application ID

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/app" element={<TenantPage />} />
          <Route path="/*" element={<MainPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/contact" element={<ContactPage/>} />
          <Route path="/hris" element={<HRISPage />} />
          <Route path="/dms" element={<DMSPage/>} />
          <Route path="/bis" element={<BISPage/>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
